import { MealPlanPreferenceStateVariableNames } from '@akin-home/meals';
import { useGetStateVariable } from './useGetStateVariable';

export const useServingsVariable = () => {
  const result = useGetStateVariable(
    MealPlanPreferenceStateVariableNames.PEOPLE
  );
  const servings = result.data?.value as number | undefined;

  return {
    ...result,
    servings,
  };
};
